
module.exports = {
    /**
     * Ricerca Binaria per trovare il nodo con un determinato identificativo
     * @param {Array} array - L'array ordinato su cui cercare il nodo
     * @param {string} element_id - L'identificativo del nodo da cercare
     * @return {Object} Il nodo trovato, oppure null
     */
    find: function (array, element_id) {
      var inf = 0;
      var sup = array.length - 1;

      if (sup === -1 || element_id < parseInt(array[0].id, 10) || element_id > parseInt(array[sup].id, 10)) return null;

      while (inf <= sup) {
        var i = Math.floor((inf + sup) / 2);
        if (element_id < parseInt(array[i].id, 10)) sup = i - 1;
        else if (element_id > parseInt(array[i].id, 10)) inf = i + 1;
        else return array[i];
      }
      return null;
    },

    /**
     * Funzione per ordinare secondo il campo ordine del nodo
     */
    ordina: function (a, b) {
      return a.ordine - b.ordine;
    },

    /**
     * Funzione per ordinare secondo l'identificativo dei nodi
     */
    sortTreeNode: function (a, b) {
      if (parseInt(a.id, 10) < parseInt(b.id, 10)) {
        return -1;
      }
      if (parseInt(a.id, 10) > parseInt(b.id, 10)) {
        return 1;
      }
      return 0;
    },

    /**
     * Funziona che gestisce le classi e l'animazione quando apro o chiudo un nodo
     * @param {DOM} jelem - Riferimento jQuery dell'albero
     * @param {function} apri - Funzione che apre effettivamente un nodo
     * @param {string} load - HTML dell'icona di caricamento di un nodo, di default stampa i tre pallini
     */
    clickHierarchyItem: function (jelem, apri, load = '<span id="load" class="spinner"><span class="bounce1"></span><span class="bounce2"></span><span class="bounce3"></span></span>') {
      jelem.find('.wpca-parent-container').on('click', '.toggler.fold', function () {
        var containerId = jQuery(this).parent('').parent('').data('id')
        var containerTable = jQuery(this).parent('').parent('').data('table')
        var level = jQuery(this).parent('').parent('').data('level') + 1
        jelem.find('#wpca-parent-container_' + containerTable + '_' + containerId).append(load)
        apri(containerId, level)
        jelem.find('#wpca-parent-container_' + containerTable + '_' + containerId).closest('li').toggleClass('closed open')
        jQuery(this).removeClass('fold').addClass('unfold')
        jQuery(this).find('.fa').toggleClass('fa-plus fa-minus')
  
        return false
      })
  
      jelem.find('.wpca-parent-container').on('click', '.toggler.unfold', function () {
        var containerId = jQuery(this).parent('').parent('').data('id')
        var level = jQuery(this).parent('').parent('').data('level') + 1
        apri(containerId, level)     
        jQuery(this).parent().parent().children('.no-bullet').remove()
        jQuery(this).removeClass('unfold').addClass('fold')
        jQuery(this).closest('li').removeClass('open').addClass('closed')
        jQuery(this).find('.fa').toggleClass('fa-plus fa-minus')
        return false
      })
      return false
    },
};



// WEBPACK FOOTER //
// ./src/js/components/hierarchytree/hierarchyUtils.js